import "./loader.css";
import { useSelector } from "react-redux";
import { themes } from "../../pages/Game/theme";


//========================== THIS IS Spinner COMPONENT ======================
const Spinner = ({ type }) => {
  const { user } = useSelector((store) => store.auth);
  const loader = 
   '/logo.png';
  // themes[user.theme].loaderImgSm;

  //================== FIXED ===========================
  if (type === "fixed") {
    return (
      <div className="fixed-loading-wrapper">
        <div className="loader-wrap">
          <div className="loader-logo">
            <img src={loader} alt="Dreamhoops" width="36" height="31" />
          </div>
          <div className="loader"></div>
        </div>
      </div>
    );
  }
  //========================== NORMAL WEB LOADER =====================
  else if (type === "webLoader") {
    return (
      <div className="fixed-loading-wrapper web-loader">
        <img src={loader} alt="Dreamhoops" width="36" height="31" />
      </div>
    );
  }
  //=========== JUST SPINNER ==========
  if (type === "spinner") {
    return (
      <div className="loading-wrapper sm_spinner">
        <div className="loader-wrap">
          <div className="loader"></div>
        </div>
      </div>
    );
  }
  //=========== SPINNER with logo ==========
  return (
    <div className="loading-wrapper">
      <div className="loader-wrap">
        <div className="loader-logo">
          <img src={loader} alt="Dreamhoops" width="36" height="31" />
        </div>
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Spinner;
